// src/apis/storageServiceInitializer.js
let storageService;
let isStorageServiceInitialized = false;

export const initializeStorageService = async () => {
  if (isStorageServiceInitialized) return;

  const storageProvider = process.env.REACT_APP_STORAGE_PROVIDER;

  switch (storageProvider) {
    case 'firebase':
      const { default: FirebaseStorageService } = await import('services/storage/FirebaseStorageService');
      storageService = new FirebaseStorageService();
      break;
      
    /* case 'aws':
      const { default: AWSStorageService } = await import('services/AWSStorageService');
      storageService = new AWSStorageService();
      break; */

    default:
      throw new Error(`Unsupported storage provider: ${storageProvider}`);
  }

  isStorageServiceInitialized = true;
};

export const getStorageService = () => {
  if (!storageService) {
    throw new Error('StorageService has not been initialized. Call initializeStorageService first.');
  }
  return storageService;
};
